import React from "react";
//#region types
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { RutRotSelectorProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { FormFieldLayout } from "components/common/wintForms";
import { MultipleSelection } from "components/common";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

const QuotationRutRotSelector: React.FC<RutRotSelectorProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { connect, values } = props;
  const houseWorkType = values.rutRot?.houseWorkType!;

  const onRutRotArticleChange = (selectedItems: SelectionItem[]) => {
    const newValues = selectedItems.map((selectedItem) => {
      const existing = values.rutRot?.rutRotArticles?.find((article) => article.id === selectedItem.id);
      return (
        existing ?? {
          id: selectedItem.id as number,
          name: selectedItem.value,
        }
      );
    });
    connect("rutRot").setValue({ ...values.rutRot, rutRotArticles: newValues }, true);
  };

  const rutRotArticleConnector = connect("rutRot.rutRotArticles");
  const rutRotArticleTouched = rutRotArticleConnector.touched ?? false;

  return (
    <FormFieldLayout
      label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RutRotServices)}
      descriptionText={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Invoice.RutRotServicesDescription,
        "",
        { houseWorkType: invoiceService.getRutOrRotText(houseWorkType) }
      )}
      direction="horizontal"
      error={rutRotArticleConnector.error}
      hasError={rutRotArticleTouched && !!rutRotArticleConnector.error}
    >
      <MultipleSelection
        items={
          values.products
            ?.filter((p: InvoiceFormTypes.Product) => p.text)
            .map((item: InvoiceFormTypes.Product) => ({
              id: item.uniqueId ?? UtilsHelper.getUniqueId(),
              value: item.text!,
            })) ?? []
        }
        value={(values.rutRot?.rutRotArticles ?? []).map((article: InvoiceFormTypes.RutRotArticleItem) => ({
          id: article.id,
          value: article.name ?? "",
        }))}
        onChange={onRutRotArticleChange}
      />
    </FormFieldLayout>
  );
};

export default QuotationRutRotSelector;
